require('../layout');
require("slick-carousel");

$("#differences").find('.slide').slick({
    arrows: true,
    dots: false,
    infinite: true,
    speed: 300,
    autoplay: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    fade: false,
    prevArrow: $("#differences").find(".arrows .prev"),
    nextArrow: $("#differences").find(".arrows .next"),
    responsive: [
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                fade: true,
            }
        },
        {
            breakpoint: 575,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                fade: true,
            }
        }
    ]
})